import React, { useRef, useEffect,useState } from "react";
import { useFintechLayouts, } from "../services/AsaApiServices";
import { useIsFetching, useIsMutating } from "react-query";
import { useIsLoading } from '../services/AsaSessionServices'
const radius = 80;
const lineWidth = 15;
const animationDuration = 2000; // milliseconds
const animationDelay = 500; // milliseconds

class ProgressBar {
  constructor(

  ) {

  }
  
currentProgress = 0;
animationId=0;

drawProgressBar  (progress: number, animateprogress:number, canvas: HTMLCanvasElement) {
  const ctx = canvas.getContext('2d')!;
  const centerX = canvas.width / 2;
  const centerY = canvas.height / 2;
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  // Draw the progress as segmented arc with rainbow effect
  const totalSegments = 60;
  const gapAngle = Math.PI / 60;
  const fullCircle = Math.PI * 2;
  const filledSegments = Math.round((progress / 100) * totalSegments);

  for (let i = 0; i < totalSegments; i++) {
    const startAngle = -Math.PI / 2 + i * (fullCircle / totalSegments);
    const endAngle = startAngle + (fullCircle / totalSegments) - gapAngle;
    ctx.beginPath();
    ctx.arc(centerX, centerY, radius, startAngle, endAngle);

    if (i < filledSegments) {
      // Animate the hue based on progress for a moving rainbow effect
      const hue = ((i * 360) / totalSegments + animateprogress * 3.6) % 360;
      ctx.strokeStyle = `hsl(${hue}, 90%, 55%)`;
    } else {
      ctx.strokeStyle = '#e0e0e0';
    }
    ctx.lineWidth = lineWidth;
    ctx.stroke();
  }

  // Draw the percentage text
  ctx.fillStyle = '#bababa';
  ctx.font = '24px Arial';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(`${Math.round(progress)}%`, centerX, centerY);
}

stopAnimation() {
  if (this.animationId) {
    cancelAnimationFrame(this.animationId);
    this.animationId = 0;
  }
}
animateProgress (targetProgress: number, canvas: HTMLCanvasElement) {
  const startTime = performance.now();
  const startProgress = this.currentProgress;
  const me=this;
  function frame(currentTime: number) {
    const elapsedTime = currentTime - startTime;
    //const progressRatio = Math.min(elapsedTime / animationDuration, 1);
   // me.currentProgress = startProgress + (targetProgress - startProgress) * progressRatio;
   
    // For rainbow animation, use time as part of the progress
    me.drawProgressBar(targetProgress ,performance.now() % targetProgress, canvas);

    setTimeout(()=>{
      me.animationId= requestAnimationFrame(frame)}
      ,animationDelay);
  }
  this.animationId=requestAnimationFrame(frame);
  //setTimeout(()=>requestAnimationFrame(frame),1000);
}

}
const progress=new ProgressBar();
const LoaderComponent = () => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const layout = useFintechLayouts();
  const isFetching = useIsFetching();
  const isMutating = useIsMutating();
  
  const totalRequest = isFetching + isMutating;
  const [isLoading, ] = useIsLoading();
  //const isLoading = totalRequest > 0;
  const [showLoader, setShowLoader] = useState(true);
  
  useEffect(() => {
    if (isLoading) {
      setShowLoader(true);
    } else {
      // Wait for the fade-out transition before unmounting
      const timeout = setTimeout(() => setShowLoader(false), 1000);
      return () => clearTimeout(timeout);
    }
  }, [isLoading]);
  /*
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !!layout) return;
    const currentProgress = totalRequest > 0 ? (100 / totalRequest) : 0;
    progress.stopAnimation();
    progress.animateProgress(currentProgress, canvas); // Animate to 100%
        return () => {
      // Clear the timer when the component unmounts or dependencies change
      progress.stopAnimation();
    };
  }, [totalRequest,layout]);
  */
  if(!showLoader) {
    return null; // Don't render anything if not loading
  }
  return (
    
   <div className={`loader-container ${!!layout?'':'loader-container-init'} loader-fade ${isLoading ? "fade-in" : "fade-out"}`}>
    {/*
     { !!!layout && 
      <canvas ref={canvasRef} width={600} height={400} style={{ border: '1px solid black' }} />
     }
     { !!layout &&
      <div className="loader"></div>
     }
    */}
     <div className="loader"></div>
    </div>

    
  );
};


export default LoaderComponent;
